import { RdpReachability } from "@cloudserver/contracts";
import { useQuery } from "@tanstack/react-query";
import { api } from "./client.js";

/*
 * The remote desktop (docs/rdp.md): whether the gateway exists and the
 * server's firewalls let it reach port 3389. Sessions themselves are
 * opened by `rdp/connection.ts`.
 */

export const useRdpReachability = (projectId: string, serverId: string, enabled = true) =>
  useQuery({
    queryKey: ["projects", projectId, "servers", serverId, "rdp", "reachability"],
    queryFn: () =>
      api(`/projects/${projectId}/servers/${serverId}/rdp/reachability`, {
        schema: RdpReachability,
      }),
    enabled,
  });
